import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-timesearch',
  templateUrl: './timesearch.component.html',
  styleUrls: ['./timesearch.component.scss']
})
export class TimesearchComponent implements OnInit {
  @Output() submitEvent = new EventEmitter<Object>();
  date = null;
  inputValue = "";
  startDate: string = "";
  endDate: string = "";

  ngOnInit(): void {
    // do something
  }

  onChange(result: Date[]): void {
    this.startDate = result[0] ? moment(result[0]).format('YYYY-MM-DD 00:00:00') : "";
    this.endDate = result[1] ? moment(result[1]).format('YYYY-MM-DD 23:59:59') : "";
  }
  submit() {
    let body = {};
    if (this.startDate !== "") {
      body['timeRange'] = {};
      body['timeRange']['startTime'] = this.startDate;
      body['timeRange']['endTime'] = this.endDate;
    }
    if (this.inputValue != "") {
      this.inputValue = this.inputValue.replace(/\s*/g, "");//去除字符串内所有的空格
      body['queryValue'] = this.inputValue;
    }
    this.submitEvent.emit(body);
  }
}
